module.exports = __webpack_public_path__ + "static/img/app_share_img.bcc8d5b.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/app_share_img.png
// module id = HOw2
// module chunks = 272